var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import html from "./footer.html";
import { Topics } from "../app-lib/constants";
import "./footer.scss";
import Component from "../lib/component";
var MyComponent = /** @class */ (function (_super) {
    __extends(MyComponent, _super);
    function MyComponent() {
        var _this = _super.call(this, "footer", html) || this;
        _this.linkPaths = [];
        return _this;
    }
    MyComponent.prototype.init = function () {
        var _this = this;
        ko.applyBindings({}, this.container);
        ko.postbox.subscribe(Topics.app_location_changed, function (v) {
            if (_this.links == null) {
                _this.links = document.querySelectorAll(".footerContainer > div");
                for (var i = 0; i < _this.links.length; ++i) {
                    var link = _this.links[i];
                    var bindString = link.getAttribute("data-bind");
                    var path = bindString.substring(9);
                    path = path.substring(0, path.indexOf("/"));
                    _this.linkPaths.push(path);
                }
            }
            var currentPath = v;
            currentPath = currentPath.substring(0, currentPath.indexOf("/"));
            for (var i = 0; i < _this.links.length; ++i) {
                var link = _this.links[i];
                if (currentPath === _this.linkPaths[i])
                    link.classList.add("active");
                else
                    link.classList.remove("active");
            }
        });
    };
    return MyComponent;
}(Component));
export { MyComponent };
export default new MyComponent();
